import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { SettingsCardImgs, SettingsCardImgsMap } from './SettingsCardImg';
import style from './SettingsCard.module.scss';
import { useTranslation } from 'react-i18next';

const { Box, Button } = vp;

export type SettingsCardProps = {
  Title: string;
  Image: SettingsCardImgs;
  onClickDetails: () => void;
  isLocked?: boolean;
};

type FC = FunctionComponent<SettingsCardProps>;
const SettingsCard: FC = ({ Title, onClickDetails, Image, isLocked }: SettingsCardProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'UI.SettingsCard' });

  return (
    <div className={style.Card}>
      <Box flx="col">
        <img className={style.Image} src={SettingsCardImgsMap[Image].src} alt={SettingsCardImgsMap[Image].alt} />
        <div className={style.bottomSection}>
          <h3 className={style.Title}>{Title}</h3>
          {isLocked ? (
            <Button
              icon="lock2"
              iconLocation="center"
              color="locked"
              width="100%"
              label={t('detailsButton')}
              size="sm"
              id="details"
              onClick={onClickDetails}
            />
          ) : (
            <Button
              color="yellow"
              width="100%"
              label={t('detailsButton')}
              size="sm"
              id="details"
              onClick={onClickDetails}
            />
          )}
        </div>
      </Box>
    </div>
  );
};
export default SettingsCard;
